import { render, staticRenderFns } from "./KindList.vue?vue&type=template&id=5c966402"
import script from "./KindList.vue?vue&type=script&lang=js"
export * from "./KindList.vue?vue&type=script&lang=js"
import style0 from "./KindList.vue?vue&type=style&index=0&id=5c966402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports